const amount = value => {
  if (value == null || String(value).trim() === "") return null;
  const number = Number(String(value).replace(",", "."));
  return Number.isFinite(number) ? number : null;
};
export function outstandingInvoices(invoices) {
  let cents = 0;
  let count = 0;
  let unknown = 0;
  invoices.forEach(invoice => {
    if (invoice.FactureRegle === "OUI") return;
    const partial = invoice.FactureRegle === "PARTIEL" || invoice.FacturePartiellementReglee;
    if (invoice.FactureRegle !== "NON" && !partial) return;
    const total = amount(invoice.montantTTC ?? invoice.TotalTTC);
    const remaining = amount(invoice.montantRestant);
    const paid = amount(invoice.paiementTotal ?? invoice.paidAmount ?? invoice.montantPaye);
    const balance = remaining ?? (total != null && paid != null ? total - paid : partial ? null : total);
    if (balance == null) { count++; unknown++; return; }
    if (balance > 0) { count++; cents += Math.round(balance * 100); }
  });
  return {count, amount: cents / 100, unknown};
}
